import * as React from 'react';
import './LoginComponent.css';

import {t} from 'react-multi-lang';

interface ILoginComponentProps {
    login: (instanceID: string, password: string) => any
}

interface ILoginComponentState {
    instanceID: string,
    password: string
}

class LoginComponent extends React.Component<ILoginComponentProps, ILoginComponentState> {
    constructor(props: ILoginComponentProps) {
        super(props);

        this.state = {
            instanceID: '',
            password: ''
        };

        this.handleInstanceID = this.handleInstanceID.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return (
            <div className="w_login_container">
                <div className="w_login_component col-11 col-sm-8 col-md-6 col-lg-4 pt-3">
                    <h1>{t('login.login')}</h1>
                    <span className="text-center">{t('login.instructions')}</span>
                    <form onSubmit={this.handleSubmit}>
                        <label htmlFor="login_instanceID">{t('login.project_name')}:</label>
                        <input className="w_component_row form-control" type="text" id="login_instanceID"
                               name="instanceID"
                               required={true} value={this.state.instanceID} onChange={this.handleInstanceID}/>
                        <label htmlFor="login_password">{t('login.password')}:</label>
                        <input className="w_component_row form-control" type="password" id="login_password"
                               name="password"
                               required={true} value={this.state.password} onChange={this.handlePassword}/>
                        <input type="submit" className="w_btn_upload btn mt-2 pl-3 pr-3" value={t('login.button')}/>
                    </form>
                </div>
            </div>
        );
    }

    private handleInstanceID(event: any) {
        this.setState({
            ...this.state,
            instanceID: event.target.value
        });
    }

    private handlePassword(event: any) {
        this.setState({
            ...this.state,
            password: event.target.value
        });
    }

    private handleSubmit(event: any) {
        event.preventDefault();
        this.props.login(this.state.instanceID, this.state.password);
    }
}

export default LoginComponent;


// WEBPACK FOOTER //
// ./src/components/LoginComponent/LoginComponent.tsx